var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"NavCtrls"},[_c('arrow-bttn',{staticClass:"NavCtrls-back",attrs:{"light":_vm.light,"disabled":_vm.disableBack,"up":""},on:{"click":function($event){_vm.$emit('back')}}}),_vm._v(" "),_c('arrow-bttn',{staticClass:"NavCtrls-next",attrs:{"light":_vm.light,"disabled":_vm.disableNext},on:{"click":function($event){_vm.$emit('next')}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6516f394","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/NavCtrls.vue
// module id = null
// module chunks = 